import React from 'react';
import ReactDOM from 'react-dom/client';

import EventSearchCompact from './EventSearchCompact';

const root = ReactDOM.createRoot(
  document.getElementById('event_search_compact'),
);

root.render(
  <React.StrictMode>
    <EventSearchCompact />
  </React.StrictMode>,
);
